module.exports = __webpack_public_path__ + "static/media/lock.d26f08c9.svg";